import { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./test_content_component1.scss";
import TestInstructionsView1 from "./test_instructions_view/test_instructions_view1";
import TestQuestionsView1 from "./test_questions_view/test_questions_view1";
import userTestsExercisesAction from "../../../../../../redux/user_tests_exercises/action";
import { Analytics } from "aws-amplify";
import {
  url_24,
  url_26,
  url_81,
  url_88,
  url_76,
  url_39,
  url_174,
  url_175,
  url_25,
  url_27,
  url_143,
} from "../../../../../../custom_utilities/api_services";
import axios from "axios";
import { isEmpty } from "../../../../../../custom_utilities/custom_useful_functions";
//Redux
import { connect } from "react-redux";
import uiActions from "../../../../../../redux/ui/action";
import RewardModal from "../../../../../../components/RewardModal/RewardModal";
import CoinUsesModal from "../../../../../../components/CoinUsesModal/CoinUsesModal";
import {
  applyExerciseProgress,
  applyQuestionAnswerEvaluation,
  buildTopicExerciseSavePayload,
  buildTopicExerciseSubmitSummary,
  clearExerciseProgress,
  extractPaperIdFromResponse,
  getExerciseApiPayload,
  getExerciseProgressParams,
  initExerciseQuestionClientState,
  isTopicExerciseFlow,
  markExerciseAsSubmitted,
  normalizeExerciseQuestions,
  persistExerciseProgress,
  persistExerciseSummary,
  readExerciseProgress,
  resolveExercisePaperId,
  resolveResumeQuestionIndex,
  withResolvedPaperId,
} from "./exercisePaperIdUtils";

const TestContentComponent1 = (props) => {
  let {
    history,
    userData,
    testData,
    topicData,
    setUserTestsResultData,
    userPreference,
    startLoading,
    finishLoading,
    subjectData,
    test_type,
  } = props;

  const routerHistory = useHistory();
  const navigationHistory = history || routerHistory;

  const [state, setState] = useState({
    step: 1,
    testDetails: {},
    testQuestionsDetails: [],
    subjecSectiontWiseTestQuestions: {},
    checkQuestion: {},
    currentQuestion: 0,
    countDownTimer: {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    initialTime: 0,
    useTime: 0,
    viewVideo: false,
    earnedCoins: 0,
    coinPopup: false,
    reason: "RewardModal",
    coinDetailsPopup: false,
    coinUsesPoints: [],
    textResultData: {},
  });
  const [selectedSubject, setSubject] = useState("");
  const [selectedSection, setSection] = useState("");

  const handleSubjectChange = (subject) => {
    const section = Object.keys(
      state.subjecSectiontWiseTestQuestions[subject]
    )[0];
    setSubject(subject);
    setSection(section);
    const currentQuestion =
      state.subjecSectiontWiseTestQuestions[subject][section][0]["matchIndex"];
    setState((prevState) => ({
      ...prevState,
      currentQuestion,
    }));
  };
  const handleSectionChange = (section) => {
    setSection(section);
    const currentQuestion =
      state.subjecSectiontWiseTestQuestions[selectedSubject][section][0][
        "matchIndex"
      ];
    setState((prevState) => ({
      ...prevState,
      currentQuestion,
    }));
  };

  useEffect(() => {
    if (state.testQuestionsDetails.length) {
      setSubject(state.testQuestionsDetails[state.currentQuestion]["subject"]);
      setSection(
        state.testQuestionsDetails[state.currentQuestion]["section_name"]
      );
    }
  }, [state.currentQuestion, state.testQuestionsDetails]);

  useEffect(() => {
    getTestDetails();
    coinUsesApi();
  }, []);

  useEffect(() => {
    if (state.step === 2) {
      createCountDownTimer(state.testDetails.duration_mins);
    }
    return () => {
      clearInterval(timeInterval);
    };
  }, [state.step]);

  let timeInterval;
  const createCountDownTimer = (duration) => {
    let useTime = state.useTime ?? 0;
    useTime = useTime * 1000;

    // duration  is in minutes, first convert it to milliseconds
    let countdownTime = duration * 60 * 1000 + new Date().getTime();
    countdownTime = countdownTime - useTime;

    timeInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countdownTime - now;
      if (distance < 0) {
        clearInterval(timeInterval);
      }
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setState((prevState) => ({
        ...prevState,
        countDownTimer: {
          ...prevState.countDownTimer,
          hours,
          minutes,
          seconds,
        },
      }));
    }, 1000);
  };

  const getTestDetails = () => {
    const paperId = resolveExercisePaperId(testData);
    setState((prevState) => ({
      ...prevState,
      testDetails: withResolvedPaperId(testData, paperId),
    }));
  };

  const getTestQuestionsList = async (testDetails) => {
    if (test_type.state.type === "dpp") {
      let data = {
        excersie_type: testDetails.excersie_type,
        course_id: userPreference.courseDetails[0].course_id,
        topic_id: topicData.topicId,
        video_id: testDetails.videoId,
      };
      startLoading();
      try {
        const response = await axios.post(url_24, data);
        if (response.data.status === 200) {
          Analytics.record({
            name: "web_dpp_start_test",
            attributes: {
              dpp_type_Name: data.excersie_type,
              topic_id: topicData.topicId,
              topic_name: topicData.topicName,
              subject_id: subjectData?.subjectId,
              subject_name: subjectData.subjectName,
              video_id: data.video_id,
            },
          });
          finishLoading();
          return {
            result: 1,
            data: { apiData: response.data },
          };
        } else {
          finishLoading();
          alert(response.data.message);
          history.push("/store");
          return {
            result: 0,
            data: { apiData: {} },
          };
        }
      } catch (error) {
        console.log(error);
        finishLoading();
        history.push("/store");
        return {
          result: 0,
          data: { apiData: {} },
        };
      }
    } else if (test_type.state.type === "exercise") {
      let data = {
        excersie_type: testDetails.excersie_type,
        course_id: userPreference.courseDetails[0].course_id,
        topic_id: topicData.topicId,
        // answer_type_id: 4,
        // answer_type: "Subjective",
      };
      startLoading();
      try {
        const response = await axios.post(url_26, data);
        if (response.data.status === 200) {
          Analytics.record({
            name: "web_exercise_start_test",
            attributes: {
              Exercise_type_Name: data.excersie_type,
              topic_id: topicData.topicId,
              topic_name: topicData.topicName,
              subject_id: subjectData?.subjectId,
              subject_name: subjectData.subjectName,
            },
          });
          finishLoading();
          return {
            result: 1,
            data: { apiData: response.data },
          };
        } else {
          finishLoading();
          alert(response.data.message);
          history.push("/store");
          return {
            result: 0,
            data: { apiData: {} },
          };
        }
      } catch (error) {
        finishLoading();
        history.push("/store");
        return {
          result: 0,
          data: { apiData: {} },
        };
      }
    }
  };

  const getNowTime = () => {
    let d = new Date();
    return d.getTime();
  };

  const saveExerciseProgressToStorage = (
    questions,
    currentQuestion,
    testDetails = state.testDetails
  ) => {
    const progressParams = getExerciseProgressParams({
      testDetails,
      userData,
      userPreference,
      topicData,
    });
    if (!progressParams) return;

    persistExerciseProgress({
      ...progressParams,
      questions,
      currentQuestion,
    });
  };

  const startBtn = async () => {
    let testDetails = { ...state.testDetails };
    if (!isEmpty(testDetails)) {
      let returnedResponse = await getTestQuestionsList(testDetails);
      console.log("returnedResponse----", returnedResponse);

      if (returnedResponse.result) {
        const apiRoot = returnedResponse.data.apiData;
        const apiPayload = getExerciseApiPayload(apiRoot);
        const apiResumeIndex = await checkIsResumeTest(apiPayload);
        const resolvedPaperId = resolveExercisePaperId(
          testDetails,
          apiPayload?.AllQuestionList,
          apiPayload,
          apiRoot
        );
        const allQuestionList = normalizeExerciseQuestions(
          apiPayload?.AllQuestionList || [],
          resolvedPaperId
        );

        allQuestionList.forEach(
          (element) => {
            initExerciseQuestionClientState(element);
            if (element.solution !== null) {
              element.q_text = element.q_text
                ?.replaceAll(
                  'src="ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'src="/ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="/ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="./ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC= "ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                );
              element.solution = element.solution
                .replaceAll(
                  'src="ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'src="/ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="/ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="./ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC= "ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                );
            }
            element.option.forEach((opt) => {
              opt.option = opt.option
                .replaceAll(
                  'src="ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'src="/ckfinder',
                  'src="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="/ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC="./ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                )
                .replaceAll(
                  'SRC= "ckfinder',
                  'SRC="http://quizmaster.motion.ac.in/ckfinder'
                );
            });
          }
        );
        const progressParams = getExerciseProgressParams({
          testDetails,
          userData,
          userPreference,
          topicData,
        });
        const savedProgress = progressParams
          ? readExerciseProgress(progressParams)
          : null;
        const questionsWithProgress = applyExerciseProgress(
          allQuestionList,
          savedProgress
        );
        const currentQuestion = resolveResumeQuestionIndex({
          savedProgress,
          apiResumeIndex,
          totalQuestions: questionsWithProgress.length,
        });
        let time = getNowTime();

        setState((prevState) => ({
          ...prevState,
          step: 2,
          testDetails: withResolvedPaperId(testDetails, resolvedPaperId),
          testQuestionsDetails: questionsWithProgress,
          initialTime: time,
          useTime: returnedResponse.data.apiData.total_time,
          currentQuestion,
        }));
      }
    } else {
      alert("You don't have Test Detail");
    }
  };

  const checkIsResumeTest = async (test) => {
   

    const currentIndex = test?.AllQuestionList.findIndex(
      (elem) => elem.qid === test.UserGivenLastQuestionId
    );

    return currentIndex;

  
  };

  const getCalculatedTime = (initialTime) => {
    let d = new Date();
    let time = d.getTime();

    let calculatedTime = Math.round((time - initialTime) / 1000);

    return calculatedTime;
  };

  const persistPaperIdFromResponse = (response) => {
    const nextPaperId = extractPaperIdFromResponse(response);
    if (!nextPaperId) return;

    setState((prevState) => ({
      ...prevState,
      testDetails: withResolvedPaperId(prevState.testDetails, nextPaperId),
      testQuestionsDetails: normalizeExerciseQuestions(
        prevState.testQuestionsDetails,
        nextPaperId
      ),
    }));
  };

  const handleSaveQuestion = async (options = {}) => {
    const { skipLoader = false } = options;
    let { currentQuestion, testQuestionsDetails, testDetails } = state;
    let crntQuestionDetail = testQuestionsDetails[currentQuestion];
    if (!crntQuestionDetail) return null;

    const paperId = resolveExercisePaperId(testDetails, testQuestionsDetails);
    const topicExerciseFlow = isTopicExerciseFlow(testDetails);
    const testType = test_type?.state?.type;
    const saveApi =
      testType === "dpp"
        ? url_25
        : topicExerciseFlow
        ? url_27
        : url_88;

    let data;

    if (topicExerciseFlow) {
      data = buildTopicExerciseSavePayload({
        testDetails,
        question: crntQuestionDetail,
        userPreference,
        topicData,
        userData,
        testType: test_type?.state?.type,
        calculatedTime: crntQuestionDetail.totalTimeTaken,
      });
    } else {
      const filteredOptions = crntQuestionDetail?.userAnswerCollection?.map(
        (elem) => elem.option_id
      );

      data = {
        negative_marks: crntQuestionDetail.negative_marks,
        option_id: crntQuestionDetail.userAnswerCollection.length
          ? [...filteredOptions]
          : crntQuestionDetail.answer_type == "Integer Correct"
          ? crntQuestionDetail.integer_answer
          : "",
        paper_id: paperId,
        partial_marks: crntQuestionDetail.partial_marks,
        positive_marks: crntQuestionDetail.positive_marks,
        qid: crntQuestionDetail.qid,
        subject: crntQuestionDetail.subject,
        time: crntQuestionDetail.totalTimeTaken,
        topic_name: crntQuestionDetail.topic_name,
        toughness: crntQuestionDetail.toughness,
        course_id: userPreference.courseDetails[0].course_id,
        topic_id: topicData.topicId,
        type:
          test_type.state.type === "dpp" ? "Attending_DPP" : "Attending_EXERCISE",
        paper_type: test_type.state.type === "dpp" ? "DPP" : "EXERCISE",
        exercise_type: testDetails.excersie_type,
        video_id: testDetails.videoId,
        user_id: userData.user_id,
        is_saved: 0,
        total_time: crntQuestionDetail.totalTimeTaken,
        type_id: crntQuestionDetail.type_id,
        right_answer: true,
        wrong_answer: false,
      };
    }

    if (!skipLoader) {
      startLoading();
    }
    try {
      const response = await axios.post(saveApi, data);
      if (response.data.status === 200) {
        if (!isTopicExerciseFlow(testDetails)) {
          persistPaperIdFromResponse(response);
        }
        if (!skipLoader) {
          finishLoading();
        }
        return extractPaperIdFromResponse(response);
      }
      if (!skipLoader) {
        finishLoading();
      }
      return null;
    } catch (error) {
      console.log(error);
      if (!skipLoader) {
        finishLoading();
      }
      return null;
    }
  };

  const saveCurrentQuestionProgress = () => {
    const { currentQuestion, testQuestionsDetails, testDetails } = state;
    const currentQuestionDetail = testQuestionsDetails[currentQuestion];
    const answerType = String(
      currentQuestionDetail?.answer_type || ""
    ).toLowerCase();
    const paperId = resolveExercisePaperId(testDetails, testQuestionsDetails);

    if (answerType === "integer correct" && paperId) {
      handleCheckQuestion();
      return;
    }

    saveExerciseProgressToStorage(
      testQuestionsDetails,
      currentQuestion,
      testDetails
    );
    handleSaveQuestion();
  };

  const handlePreviousQuestionBtn = () => {
    let { currentQuestion, initialTime, testQuestionsDetails } = state;
    let calculatedTime = getCalculatedTime(initialTime);

    testQuestionsDetails[currentQuestion].totalTimeTaken = calculatedTime;
    let time = getNowTime();
    saveCurrentQuestionProgress();
    setViewVideoFalse();
    if (currentQuestion >= 1) {
      setState((prevState) => ({
        ...prevState,
        currentQuestion: currentQuestion - 1,
        testQuestionsDetails: testQuestionsDetails,
        initialTime: time,
      }));
      window.scrollTo(0, 0);
    }
  };

  //check question
  const handleCheckQuestion = async () => {
    let { currentQuestion, testQuestionsDetails, testDetails } = state;
    let crntQuestionDetail = testQuestionsDetails[currentQuestion];
    const paperId =
      crntQuestionDetail.paper_id ??
      resolveExercisePaperId(testDetails, testQuestionsDetails);

    if (!paperId) {
      return;
    }

    let formatData =
      testDetails.format ===
      "MAIN PATTERN TEST  [20 SINGLE, 10 NUMERIC] EACH SUBJECT"
        ? "MAIN"
        : testDetails.format === "NEET NEW PATTERN 2021 OTS"
        ? "NEET"
        : "OTHER";
    let data = {
      paper_id: paperId,
      qid: crntQuestionDetail.qid,
      subject: crntQuestionDetail.subject,
      format: formatData,
      section: crntQuestionDetail.section_name,
    };
    startLoading();
    const response = await axios.post(url_76, data);
    if (response.data.status === 200) {
      setState((prevState) => ({
        ...prevState,
        checkQuestion: response.data.data,
      }));
      finishLoading();
      if (!response.data.data) {
        testQuestionsDetails[currentQuestion].integer_answer = "";
        setState((preState) => ({
          ...preState,
          testQuestionsDetails: testQuestionsDetails,
        }));
        alert(response.data.message);
        return;
      }
      handleSaveQuestion();
    } else if (response.data.status === 422) {
      setState((prevState) => ({
        ...prevState,
        checkQuestion: response.data.data,
      }));
      handleSaveQuestion();
    }
    finishLoading();
  };

  //save prticular question

  const handleNextQuestionBtn = () => {
    let { currentQuestion, initialTime, testQuestionsDetails } = state;
    let calculatedTime = getCalculatedTime(initialTime);
    testQuestionsDetails[currentQuestion].totalTimeTaken = calculatedTime;
    saveCurrentQuestionProgress();
    setViewVideoFalse();
    //newline add

    if (
      testQuestionsDetails[currentQuestion].isAttempted ||
      testQuestionsDetails[currentQuestion].option.filter(
        (m) => m.is_user_correct_ans
      ).length
    ) {
      testQuestionsDetails[currentQuestion].isReview = false;
    } else {
      testQuestionsDetails[currentQuestion].isReview = true;
    }
    let time = getNowTime();

    saveExerciseProgressToStorage(
      testQuestionsDetails,
      currentQuestion + 1,
      state.testDetails
    );
    setState((prevState) => ({
      ...prevState,
      currentQuestion: currentQuestion + 1,
      testQuestionsDetails: testQuestionsDetails,
      initialTime: time,
    }));
    window.scrollTo(0, 0);
  };

  const handleSingleSelectAnswer = (event, optionId) => {
    let { checked } = event.target;
    let { currentQuestion, testQuestionsDetails } = state;
    const question = testQuestionsDetails[currentQuestion];

    if (checked) {
      question.userAnswerCollection = [{ option_id: optionId }];
    } else {
      question.userAnswerCollection = [];
    }

    applyQuestionAnswerEvaluation(question);
    saveExerciseProgressToStorage(
      testQuestionsDetails,
      currentQuestion,
      state.testDetails
    );
    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleMultiSelectAnswer = (_event, optionId) => {
    let { currentQuestion, testQuestionsDetails } = state;
    const question = testQuestionsDetails[currentQuestion];

    let findedIndex = question.userAnswerCollection.findIndex(
      (element) => element.option_id === optionId
    );

    if (findedIndex === -1) {
      question.userAnswerCollection.push({ option_id: optionId });
    } else {
      question.userAnswerCollection.splice(findedIndex, 1);
    }

    applyQuestionAnswerEvaluation(question);
    saveExerciseProgressToStorage(
      testQuestionsDetails,
      currentQuestion,
      state.testDetails
    );
    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleInputFieldChange = (event) => {
    let value = event;
    let sanitizedValue = value.replace(/[^\d.-]/g, "");
    // Ensure there is at most one '-' at the beginning
    sanitizedValue = sanitizedValue
      .replace(/^-/, "$#$")
      .replace(/-/g, "")
      .replace("$#$", "-");
    // Ensure there is at most one '.' and only allow up to 2 decimal places
    const dotIndex = sanitizedValue.indexOf(".");
    if (dotIndex !== -1) {
      const integerPart = sanitizedValue.substring(0, dotIndex);
      const decimalPart = sanitizedValue.substring(dotIndex + 1, dotIndex + 3);
      sanitizedValue = integerPart + "." + decimalPart;
    }
    // value = value.replace(/[^0-9]/g, "")
    let { currentQuestion, testQuestionsDetails } = state;
    testQuestionsDetails[
      currentQuestion
    ].integer_answer = sanitizedValue.trim();

    if (testQuestionsDetails[currentQuestion].integer_answer.length) {
      testQuestionsDetails[currentQuestion].isAttempted = true;
    } else {
      testQuestionsDetails[currentQuestion].isAttempted = false;
    }

    applyQuestionAnswerEvaluation(testQuestionsDetails[currentQuestion]);

    saveExerciseProgressToStorage(
      testQuestionsDetails,
      currentQuestion,
      state.testDetails
    );
    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };
  const reviewQuestion = async (currentQuestion) => {
    const { paper_id, qid, isAnswerGuessed } = currentQuestion;
    const resolvedPaperId =
      paper_id ?? resolveExercisePaperId(state.testDetails, state.testQuestionsDetails);

    if (!resolvedPaperId) {
      return;
    }

    if (test_type.state.type == "dpp") {
      let data = {
        paper_id: resolvedPaperId,
        reference_id: qid,
        status: isAnswerGuessed ? 1 : 0,
        type: 2,
      };
      const response = await axios.post(url_39, data);
    } else if (test_type.state.type == "exercise") {
      let data = {
        paper_id: resolvedPaperId,
        reference_id: qid,
        status: isAnswerGuessed ? 1 : 0,
        type: 1,
      };
      const response = await axios.post(url_39, data);
    }
  };

  const handleReview = () => {
    let { currentQuestion, testQuestionsDetails } = state;

    testQuestionsDetails[
      currentQuestion
    ].isAnswerGuessed = !testQuestionsDetails[currentQuestion].isAnswerGuessed;

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
    reviewQuestion(testQuestionsDetails[currentQuestion]);
  };

  const handleSaved = () => {
    let { currentQuestion, testQuestionsDetails, testDetails } = state;

    testQuestionsDetails[currentQuestion].is_saved = !testQuestionsDetails[
      currentQuestion
    ].is_saved;

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
    if (testQuestionsDetails[currentQuestion].is_saved) {
      let data = {
        type: 3, // 3=>test
        reference_id: testQuestionsDetails[currentQuestion].qid,
        status: 1, // 1=> save
      };
      //bookmarkApi(data);
    } else {
      let data = {
        type: 3, // 3=>test
        reference_id: testQuestionsDetails[currentQuestion].qid,
        status: 0, // 0=> unsave
      };
      //bookmarkApi(data);
    }
  };
  const handleGuessedAnswer = (event) => {
    let { checked } = event.target;
    let { currentQuestion, testQuestionsDetails } = state;

    testQuestionsDetails[currentQuestion].isAnswerGuessed = checked;

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleQuestionJump = (questionNumber) => {
    //handleSaveQuestion();
    handleCheckQuestion();
    setViewVideoFalse();
    saveExerciseProgressToStorage(
      state.testQuestionsDetails,
      questionNumber,
      state.testDetails
    );
    setState((prevState) => ({
      ...prevState,
      currentQuestion: questionNumber,
      // currentQuestion:0,
    }));
  };
  //view video
  const handleViewVideo = (videoURL) => {
    setState((prevState) => ({
      ...prevState,
      viewVideo: !state.viewVideo,
    }));
  };

  const setViewVideoFalse = () => {
    setState((prevState) => ({
      ...prevState,
      viewVideo: false,
    }));
  };

  const recordSubmitAnalytics = () => {
    let testDetails = { ...state.testDetails };
    if (test_type.state.type === "dpp") {
      Analytics.record({
        name: "web_dpp_submit_test",
        attributes: {
          dpp_type_Name: testDetails.excersie_type,
          topic_id: topicData.topicId,
          topic_name: topicData.topicName,
          subject_id: subjectData?.subjectId,
          subject_name: subjectData.subjectName,
          video_id: testDetails.video_id,
        },
      });
    } else if (test_type.state.type === "exercise") {
      Analytics.record({
        name: "web_exercise_submit_test",
        attributes: {
          Exercise_type_Name: testDetails.excersie_type,
          topic_id: topicData.topicId,
          topic_name: topicData.topicName,
          subject_id: subjectData?.subjectId,
          subject_name: subjectData.subjectName,
        },
      });
    }
  };

  const navigateToExerciseSummary = (paperId, localSummary) => {
    if (localSummary) {
      persistExerciseSummary(localSummary);
    }
    navigationHistory.replace({
      pathname: "/exercise-summary",
      state: {
        paper_id: paperId,
        localSummary,
      },
    });
  };

  const getExerciseSummaryAndAddCoins = async (paperId) => {
    try {
      const response = await axios.post(url_143, { paper_id: paperId });
      if (response.data.status === 200) {
        setState((prev) => ({
          ...prev,
          textResultData: response.data.data,
        }));
        addCoinsOnSubmission();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmitTest = async () => {
    const {
      testDetails,
      testQuestionsDetails,
      currentQuestion,
      initialTime,
    } = state;
    const activeTestDetails = testDetails?.excersie_type
      ? testDetails
      : state.testDetails;

    if (isTopicExerciseFlow(activeTestDetails)) {
      try {
        const calculatedTime = getCalculatedTime(initialTime);
        const { localSummary } = buildTopicExerciseSubmitSummary(
          testQuestionsDetails,
          currentQuestion,
          calculatedTime
        );

        const progressParams = getExerciseProgressParams({
          testDetails: activeTestDetails,
          userData,
          userPreference,
          topicData,
        });
        if (progressParams) {
          clearExerciseProgress(progressParams);
          markExerciseAsSubmitted(progressParams);
        }

        navigateToExerciseSummary(null, localSummary);
        setUserTestsResultData({ ...activeTestDetails, localSummary });

        try {
          recordSubmitAnalytics();
        } catch (analyticsError) {
          console.log(analyticsError);
        }
        addCoinsOnSubmission({ paperId: null, localSummary });
      } catch (error) {
        console.log(error);
        navigationHistory.replace("/exercise-summary");
      }
      return;
    }

    let questionArr = [];

    testQuestionsDetails.forEach((element) => {
      const answerType = element.answer_type?.toLowerCase() || "";
      if (answerType === "single correct") {
        let data = {
          qid: element.qid,
          type_id: element.type_id,
          is_saved: element.is_saved,
          total_time: element.totalTimeTaken,
          is_attempted: element.isAttempted,
          is_AnswerCorrect: element.isAnswerCorrect,
          is_GessTypeAnswer: element.isAnswerGuessed,
          paragraph_answer: element.paragraph_answer,
          integer_answer: element.integer_answer,
          positive_marks: element.positive_marks,
          negative_marks: element.negative_marks,
          partial_marks: element.partial_marks,
          CorrectAnswerId: element.correctAnswerIdCollection,
          WrongeAnswerId: element.wrongAnswerIdCollection,
          answer: element.userAnswerCollection,
          toughness_id: element.toughness_id,
          subject: element.subject,
          topic_id: element.topic_id,
        };
        if (!data.type_id) {
          data.type_id = 6;
        }
        questionArr.push(data);
      } else if (answerType === "multiple correct") {
        let data = {
          qid: element.qid,
          type_id: element.type_id,
          is_saved: element.is_saved,
          total_time: element.totalTimeTaken,
          is_attempted: element.isAttempted,
          is_AnswerCorrect: element.isAnswerCorrect,
          is_GessTypeAnswer: element.isAnswerGuessed,
          paragraph_answer: element.paragraph_answer,
          integer_answer: element.integer_answer,
          positive_marks: element.positive_marks,
          negative_marks: element.negative_marks,
          partial_marks: element.partial_marks,
          CorrectAnswerId: element.correctAnswerIdCollection,
          WrongeAnswerId: element.wrongAnswerIdCollection,
          answer: element.userAnswerCollection,
          toughness_id: element.toughness_id,
          subject: element.subject,
          topic_id: element.topic_id,
        };
        if (!data.type_id) {
          data.type_id = 6;
        }
        questionArr.push(data);
      } else if (answerType === "integer correct") {
        let data = {
          qid: element.qid,
          type_id: element.type_id,
          is_saved: element.is_saved,
          total_time: element.totalTimeTaken,
          is_attempted: element.isAttempted,
          paragraph_answer: element.paragraph_answer,
          integer_answer: element.integer_answer,
          is_AnswerCorrect: element.isAnswerCorrect,
          is_GessTypeAnswer: element.isAnswerGuessed,
          positive_marks: element.positive_marks,
          negative_marks: element.negative_marks,
          partial_marks: element.partial_marks,
          CorrectAnswerId: element.correctAnswerIdCollection,
          WrongeAnswerId: element.wrongAnswerIdCollection,
          answer: element.userAnswerCollection,
          toughness_id: element.toughness_id,
          subject: element.subject,
          topic_id: element.topic_id,
        };
        if (!data.type_id) {
          data.type_id = 6;
        }
        questionArr.push(data);
      }
    });
    startLoading();

    try {
      testQuestionsDetails[currentQuestion].totalTimeTaken =
        getCalculatedTime(initialTime);
      await handleSaveQuestion({ skipLoader: true });

      const paperId = resolveExercisePaperId(testDetails, testQuestionsDetails);

      if (!paperId) {
        alert("Paper id is required to submit this test.");
        return;
      }

      const testDetailsWithPaper = withResolvedPaperId(testDetails, paperId);
      let returnedResponse = await submitTestApi(
        userPreference,
        testDetailsWithPaper,
        questionArr
      );
      if (returnedResponse.result) {
        setUserTestsResultData(testDetailsWithPaper);
        recordSubmitAnalytics();
        getExerciseSummaryAndAddCoins(paperId);
        navigateToExerciseSummary(paperId);
      } else {
        alert(returnedResponse.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading();
    }
  };

  const submitTestApi = async (_userPreference, testDetails, _questionArr) => {
    const paperId = resolveExercisePaperId(testDetails, _questionArr);
    if (!paperId) {
      return {
        result: 0,
        data: {
          message: "Paper id is required to submit this test.",
        },
      };
    }

    let requestPayload = {
      paper_id: paperId,
      time: 84,
    };

    try {
      const response = await axios.post(url_81, requestPayload);
      if (response.data.status === 200) {
        return {
          result: 1,
          data: {
            message: response.data.message,
          },
        };
      } else {
        return {
          result: 0,
          data: {
            message: response.data.message,
          },
        };
      }
    } catch (error) {
      console.log(error);
      return {
        result: 0,
        data: {
          message:
            error?.response?.data?.message || "Something went wrong!!!",
        },
      };
    }
  };

  const handleRedirectBtn = () => {
    history.push("/pyq_cps_exam");
  };

  const renderView = (step) => {
    switch (step) {
      case 1:
        return (
          <TestInstructionsView1
            testDetails={state.testDetails}
            startBtn={startBtn}
            handleRedirectBtn={handleRedirectBtn}
          />
        );
      case 2:
        return (
          <TestQuestionsView1
            testQuestionsDetails={state.testQuestionsDetails}
            subjecSectiontWiseTestQuestions={
              state.subjecSectiontWiseTestQuestions
            }
            selectedSubject={selectedSubject}
            selectedSection={selectedSection}
            handleSubjectChange={handleSubjectChange}
            handleSectionChange={handleSectionChange}
            currentQuestion={state.currentQuestion}
            countDownTimer={state.countDownTimer}
            handlePreviousQuestionBtn={handlePreviousQuestionBtn}
            handleNextQuestionBtn={handleNextQuestionBtn}
            handleSaveQuestion={handleSaveQuestion}
            handleSingleSelectAnswer={handleSingleSelectAnswer}
            handleMultiSelectAnswer={handleMultiSelectAnswer}
            handleInputFieldChange={handleInputFieldChange}
            handleReview={handleReview}
            handleSaved={handleSaved}
            handleGuessedAnswer={handleGuessedAnswer}
            handleQuestionJump={handleQuestionJump}
            handleSubmitTest={handleSubmitTest}
            checkQuestion={state.checkQuestion}
            userData={userData}
            viewVideo={state.viewVideo}
            handleViewVideo={handleViewVideo}
            setViewVideoFalse={setViewVideoFalse}
          />
        );

      default:
        return null;
    }
  };

  const addCoinsOnSubmission = async (navigation = {}) => {
    const { testDetails } = state;
    const paperId = navigation.paperId ?? testDetails.paper_id ?? null;
    const localSummary =
      navigation.localSummary ?? testDetails.localSummary ?? null;
    let data = {};

    if (test_type.state.type === "dpp") {
      data = {
        type: "Attending_DPP",
        paper_type: "DPP",
        exercise_type: testDetails.excersie_type,
        course_id: userPreference.courseDetails[0].course_id,
        topic_id: topicData.topicId,
        video_id: testDetails.videoId,
        user_id: userData.user_id,
      };
    } else {
      data = {
        type: "Attending_EXERCISE",
        paper_type: "Exercise",
        exercise_type: testDetails.excersie_type,
        course_id: userPreference.courseDetails[0].course_id,
        topic_id: topicData.topicId,
        video_id: testDetails.videoId,
        user_id: userData.user_id,
      };
    }

    try {
      const response = await axios.post(url_174, data);
      if (response.data.status === 200) {
        if (response.data.data !== "MCoins Already Credited...!") {
          setState((prev) => {
            return {
              ...prev,
              earnedCoins: response.data.data.coins,
              coinPopup: response.data.data.coins > 0 ? true : false,
              reason: response.data.data.description,
            };
          });
          if (response.data.data.coins === 0) {
            navigateToExerciseSummary(paperId, localSummary);
          }
        } else {
          navigateToExerciseSummary(paperId, localSummary);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const coinUsesApi = async () => {
    try {
      const response = await axios.get(url_175);
      if (response.data.status === 200) {
        setState((prevState) => {
          return {
            ...prevState,
            coinUsesPoints: [...response.data.data],
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Fragment>
      <RewardModal
        show={state.coinPopup}
        onHide={() => {
          navigateToExerciseSummary(
            state.testDetails.paper_id,
            state.testDetails.localSummary
          );
        }}
        earnMoreHandler={() =>
          setState((prev) => {
            return { ...prev, coinDetailsPopup: true, coinPopup: false };
          })
        }
        earnedCoins={state.earnedCoins}
        reason={state.reason}
      />
      <CoinUsesModal
        show={state.coinDetailsPopup}
        onHide={() => {
          navigateToExerciseSummary(
            state.testDetails.paper_id,
            state.testDetails.localSummary
          );
        }}
        data={state.coinUsesPoints}
      />

      <div className="Exercise_test_content_component_wrapper">
        <div className="test_content_component_inner_wrapper">
          {renderView(state.step)}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    testData: state.userActivity.exerciseData,
    userPreference: state.userPreference,
    topicData: state.userActivity.topicData,
    subjectData: state.userActivity.subjectData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUserTestsResultData: (payload) => {
      dispatch(userTestsExercisesAction.setUserTestsResultData(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TestContentComponent1);
